<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import AppBootSkeleton from './components/AppBootSkeleton.vue';

// Mostra estrutura imediatamente enquanto a primeira navegação valida sessão e
// acesso. Depois disso, cada página controla seu próprio estado de carregamento.
const router = useRouter();
const booting = ref(true);
void router.isReady().finally(() => (booting.value = false));
</script>

<template>
  <AppBootSkeleton v-if="booting" />
  <RouterView v-else />
</template>
